<template>
    <div>
        <div class="seachBox flex">

            <div class="seachList"><span class="name">模板编号：</span>
                <a-input placeholder="请输入模板编号搜索" class="seachs search-input" allowClear v-model="seach.code"/>
            </div>
            <div class="seachList"><span class="name">颜色：</span>
                <a-select v-model="seach.a_template_color_id" class="seachs" allowClear>
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.colorList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">风格：</span>
                <a-select v-model="seach.a_template_style_id" class="seachs" allowClear>
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.styleList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
          <div class="seachList"><span class="name">上下架状态：</span>
            <a-select v-model="seach.status" class="seachs" allowClear>
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.statusList">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>

            <div class="seachList  ">   <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button> </div>

            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <div  >
            <a-button class="top_btn" type="primary" @click=" exper">
                批量导出
            </a-button>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false"/>
      </span>
            <span slot="action" slot-scope="text, record">
         <a  @click="gotoStatistics(record)">查看 </a>
      </span>
        </a-table>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "编号",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "颜色",
            dataIndex: "color_name",
            ellipsis: true,
            key: "color_name",
        },
        {
            title: "风格",
            dataIndex: "style_name",
            ellipsis: true,
            key: "style_name",
        },
      {
        title: "上下架状态",
        dataIndex: "status_name",
        ellipsis: true,
        key: "status_name",
      },
        {
            title: "使用企业总数",
            dataIndex: "used_customer_num",
            ellipsis: true,
            key: "used_customer_num",
        },
      {
        title: "正在使用企业数",
        dataIndex: "in_used_customer_num",
        ellipsis: true,
        key: "in_used_customer_num",
      },
        {
            title: "操作",
            key: "action",
            width: "100px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                seach: {
                    code: "",a_template_color_id: "", a_template_style_id: "",status:''
                },
                exportData:{ code: "",a_template_color_id: "", a_template_style_id: "", },
                seachList: {
                    styleList: [],
                    colorList: [],
                    statusList:[]
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
            }
        },
        beforeCreate() {
            this.$store.state.adminleftnavnum = "/DataStatistics/TemplateRecord"; //设置左侧导航2-2 active
        },

        mounted() {
            this.getList()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            gotoStatistics(row){
                // this.$router.push(`/DataStatistics/TemplateRecordDetails?id=${row.id}`)
                this.$router.push({path: '/DataStatistics/TemplateRecordDetails', query: {id: row.id, code:row.code}})
            },
            exper(id) {
                API.server.EXPORT({...this.exportData,ids:this.selectedRowKeys}).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.getList()
                    // this.selectedRowKeys = []
                })
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                API.server.LIST_ORDER(list_orders).then(res => {
                    this.getList()
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    code: "",a_template_color_id: "", a_template_style_id: "",
                }
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                this.exportData=seachData
                API.server.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data.data
                    this.pagination.total = res.data.data.data.total
                    this.pagination.pageSize = res.data.data.data.per_page
                    this.pagination.current = res.data.data.data.current_page
                    this.seachList= {
                        styleList:res.data.data.style,
                        colorList:res.data.data.color,
                      statusList:res.data.data.status,
                    },
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 90px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 95px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
</style>
